import React from 'react';

import { Typography } from '@crossnokaye/ux-common';

import { Stack } from '@/ux-common/components/stack/stack';

/**
 * Compressor-specific instruction content to be passed to SequencerInstructions.
 */
export const CompressorSequencerInstructionsContent: React.FC = () => {
  return (
    <Stack className="select-text mt-2">
      <Stack className="stack-thin">
        <Typography variant="h3">Overview</Typography>
        <Typography variant="body">
          <Stack className="stack-thin">
            The compressor sequencer grid is used to configure specific suction groups.
            <ul className="list-disc list-inside">
              <li>The columns in the grid indicate the Sequence Order.</li>
              <li>The rows in the grid display each compressor in the system.</li>
              <li>
                The cells in the grid display the <b>On</b>, <b>Off</b>, and <b>Trim</b> state for
                each compressor during each stage of the Sequence Order.
              </li>
              <li>
                Click the <b>Add Stage</b> button to add another stage to the sequencer.
              </li>
              <li>
                Click <b>X</b> in the last stage to remove the stage.
              </li>
            </ul>
            Metrics and Settings for the sequencer are available above in this sequencer detail
            screen.
          </Stack>
        </Typography>
      </Stack>

      <Stack className="stack-thin">
        <Typography variant="body">
          A <b>Trim Compressor</b> is the last compressor in a column to load and the first to
          unload.
        </Typography>
        <Typography variant="body">
          A <b>Swing Compressor</b> is a compressor that can belong to different Vessels and
          requires additional configuration.
        </Typography>
      </Stack>

      <Stack className="stack-thin">
        <Typography variant="h3">Check Before Saving</Typography>
        <Typography variant="body">
          <Stack className="stack-thin">
            Before saving changes, review your sequencer for the following and make any necessary
            changes to remove or alter them from the sequencer:
            <ul className="list-disc list-inside">
              <li>Empty stage = no equipment operating</li>
              <li>Duplicate stages = longer time to stage up and down</li>
              <li>
                Missing Trim = If there is no trim defined then the capacity range of the stage is
                limited which results in unstable control
              </li>
              <li>
                Multiple Trims = increased inefficiencies with each partially loaded compressor
              </li>
            </ul>
          </Stack>
        </Typography>
      </Stack>

      <Stack className="stack-thin">
        <Typography variant="h3">How to Change the Compressor State</Typography>
        <Typography variant="body">
          <ol className="list-decimal list-inside">
            <li>
              Click a cell in the grid to toggle between compressor states (<b>On</b>, <b>Off</b>,
              and <b>Trim</b>)
            </li>
            <li>
              <i>(Optional)</i> Define a dedicated Trim compressor for each stage of the Sequence
              Order. Only one Trim compressor is allowed per stage.
            </li>
            <li>
              Click <b>Save</b> at the bottom of the detail screen to preview your changes along
              with any other changes on the detail screen.
            </li>
            <li>
              Click <b>Save</b> in the preview screen to apply your changes.
            </li>
          </ol>
        </Typography>
      </Stack>

      <Stack className="stack-thin">
        <Typography variant="h3">Adding a Swing Compressor</Typography>
        <Typography variant="body">
          In the left column of the sequencer:
          <ol className="list-decimal list-inside">
            <li>
              Click the <b>X</b> to disable the desired compressor from the sequencer.
            </li>
            <li>
              Click the <b>+</b> to enable the desired compressor in the sequencer.
            </li>
          </ol>
        </Typography>
      </Stack>
    </Stack>
  );
};
